export default __webpack_public_path__ + "assets/images/4.0243e0.png";